import VirtualizedTable from "../../../Grids/VirtualizedTable";
import dayjs from "dayjs";
import APICom from "../../../../utils/helpers/APICom";
import PersistStorage from "../../../../utils/helpers/PersistStorage";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Icon } from '@iconify/react';
import phoneIcon from '@iconify-icons/mdi/phone';
import smsIcon from '@iconify-icons/mdi/email';
import checkIcon from '@iconify-icons/mdi/check-circle';
import sendIcon from '@iconify-icons/mdi/send-variant';
import closeIcon from '@iconify-icons/mdi/close-circle';
import callConfirmed from '@iconify-icons/mdi/phone-check';
import callCancel from '@iconify-icons/mdi/phone-cancel';
import phoneMissed from '@iconify-icons/mdi/phone-missed';
import Scheduled from '@iconify-icons/mdi/phone-schedule';
import refreshIcon from '@iconify-icons/mdi/refresh';

import NotScheduled from '@iconify-icons/mdi/cellphone-remove';
import SMSConfirmed from '@iconify-icons/mdi/tooltip-cellphone';
import SMSCancelled from '@iconify-icons/mdi/message-bulleted-off';
import SMSNoResponse from '@iconify-icons/mdi/message-alert';
import { toast } from 'react-toastify';
import {Modal, Button} from "react-bootstrap";
import RouteIcon from '@iconify-icons/mdi/directions-fork';
import VoicemailIcon from '@iconify-icons/mdi/voicemail';
import ModuleSecurity from "../../../../utils/helpers/ModuleSecurity";

export default function RoboCallNotification() {


    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [modalClass, setModalClass] = useState("");
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBodyHTML, setModalBodyHTML] = useState(null);
    const [modalFooterHTML, setModalFooterHTML] = useState(
        <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
          OK
        </Button>
    );

    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const tableRef           = useRef(null);
    const modalResolveRef    = useRef(null);
    const [initialSelectedRows, setInitialSelectedRows] = useState([]);

    const handleSelectedRows = async () => {
        const selectedRows = tableRef.current?.getSelectedRows() ?? [];
        const totalSelected = selectedRows.length;

        if (totalSelected === 0) {
            await showAlertModal("Please select at least one trip to send RoboCall.", "No Selection");
            return;
        }

        let selectedConfirmationNumbers = GetSelectedRowsConfirmationNo(selectedRows);
        if(selectedConfirmationNumbers){

            const initialConfirm = await showConfirmationModal(
                <>
                    You have selected <strong>{totalSelected}</strong> trip{totalSelected !== 1 ? "s" : ""}.<br />
                    Are you sure you want to send RoboCall for the selected trip{totalSelected !== 1 ? "s" : ""}?
                </>,
                "Confirm Send RoboCall"
            );
            if (initialConfirm !== true) return;

            setShowGridLoader(true);
            await CallRoboCallService(selectedConfirmationNumbers, totalSelected);
            setShowGridLoader(false);
        }
    };

    const RefreshData = async () => {
        try {

            setShowGridLoader(true);
            await fetchNotifications();
            setShowGridLoader(false);
        } catch (error) {

        }

    }
          
    function GetSelectedRowsConfirmationNo(selectedRows){
        let confirmationNumber = "";
        try {
            if(selectedRows){
                const confirmationNos =  selectedRows.map(row => row.TripNo);
                const confirmationNoList = confirmationNos.join(",");
                if(confirmationNoList != undefined){
                    confirmationNumber = confirmationNoList.toString();
                }
            }    
        } catch (error) {
            return "";
        }
        return confirmationNumber;
    }
    const [showLogsModal, setShowLogsModal] = useState(false);
    const [logsData, setLogsData] = useState([]);
    const [logsColumns, setLogsColumns] = useState([]);
    const [logsFilters, setLogsFilters] = useState({});
    const [logsColWidths, setLogsColWidths] = useState({});
    const logsColRefs = useRef({});  // direct DOM refs to <col> elements

    const filteredLogsData = logsData.filter((row) =>
        Object.entries(logsFilters).every(([col, val]) =>
            !val || String(row[col] ?? "").toLowerCase().includes(val.toLowerCase())
        )
    );

    // Pointer-capture resize for dialog table — zero re-renders during drag
    const handleLogColResize = (e, accessorKey) => {
        e.preventDefault();
        e.stopPropagation();
        const el         = e.currentTarget;
        const pointerId  = e.pointerId;
        const startX     = e.clientX;
        const startWidth = logsColWidths[accessorKey] ?? 150;

        el.setPointerCapture(pointerId);
        document.body.style.cursor     = "col-resize";
        document.body.style.userSelect = "none";

        const onMove = (mv) => {
            const newWidth = Math.max(40, startWidth + (mv.clientX - startX));
            // Direct DOM — no React state touched, no re-render
            if (logsColRefs.current[accessorKey])
                logsColRefs.current[accessorKey].style.width = `${newWidth}px`;
        };

        const onUp = (up) => {
            el.releasePointerCapture(pointerId);
            el.removeEventListener("pointermove",   onMove);
            el.removeEventListener("pointerup",     onUp);
            el.removeEventListener("pointercancel", onUp);
            document.body.style.cursor     = "";
            document.body.style.userSelect = "";
            const newWidth = Math.max(40, startWidth + (up.clientX - startX));
            // Single state update to persist the final width
            setLogsColWidths((prev) => ({ ...prev, [accessorKey]: newWidth }));
        };

        el.addEventListener("pointermove",   onMove);
        el.addEventListener("pointerup",     onUp);
        el.addEventListener("pointercancel", onUp);
    };
    const [summaryData, setSummaryData] = useState(null);

    const [rowData, setRowData] = useState([]);
    const [columns, setColumns] = useState([]);

    const columnsToHide = ["AddedFromGrid", "RoboCallPerformed"];
    
    const { loginData } = useSelector((store) => store.login);
    const { AffiliateData } = useSelector((store) => store.combinedata);

    const loginUserAffiliateList = loginData.UserAffiliateList.includes(",")
    ? loginData.UserAffiliateList.split(",")
    : [loginData.UserAffiliateList];

    const passedAff = PersistStorage.retrieve("passedAff", true);
    const currentAffiliate =
      loginUserAffiliateList.find((item) => item === String(passedAff)) ?? "";

    const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DD"));
    const tempAffiliate = AffiliateData.find(
        (item) => item.iOutTSPID.toString() === currentAffiliate.toString()
      );
      const isBroker = tempAffiliate && tempAffiliate.bBroker === 1;
      const finalAffiliate = isBroker ? tempAffiliate.iInTSPID : currentAffiliate;

    useEffect(() => {
        const fetchData = async () => {
          try {

            setShowGridLoader(true);
            await fetchNotifications();
          } finally {
            setShowGridLoader(false);
          }
        };

        fetchData();
      }, [selectedDate]);

    useEffect(() => {
        // Always start with no selections on every data load
        setInitialSelectedRows({});
    }, [rowData]);
    
    
    
    async function fetchNotifications() {
        try {
          const response = await APICom.fetchData(
            "GenericManifestDotNetCoreURL",
            `api/Notification/GetNotifications?iAffiliateId=${finalAffiliate}&date=${selectedDate}`,
            "get",
            { "Content-Type": "application/json" }
          );
    
          if (response && response.data) {
            const summary = response.data.summary;
            const data = response.data.data;
    
            setSummaryData(summary);
            setRowData(data);
    
            if (data.length > 0) {


            const cols = Object.keys(data[0]).map((key) => ({
                accessorKey: key,
                header: key.charAt(0).toUpperCase() + key.slice(1),
                enableColumnFilter: true,
                filterFn: "includesString",
            }));

            const customized = cols.map((col) => {
                if (col.accessorKey === "Sent_Time") return { ...col, size: 250 };
                if (col.accessorKey === "Customer_Name") return { ...col, size: 250 };
                if (col.accessorKey === "ResponseTimestamp") return { ...col, size: 250 };
                return col;
              });
              setColumns(customized);
            }
          }
        } catch (err) {
          console.error("Error fetching notifications:", err);
          setRowData([]);
          setColumns([]);
          setSummaryData(null);
        }
      }

      const fetchTripRefLogs = async (tripRefId) => {
          try {
              const response = await APICom.fetchData(
                  "GenericManifestDotNetCoreURL",
                  `api/Notification/GetTripRefLogs?tripRefId=${tripRefId}`,
                  "get",
                  { "Content-Type": "application/json" }
              );
              console.log("API Response:", response); 
              if (response && response.data && response.data.data?.length > 0) {
                  const data = response.data.data;

                  // Dynamically generate columns
                  const cols = Object.keys(data[0]).map((key) => ({
                      accessorKey: key,
                      header: key.charAt(0).toUpperCase() + key.slice(1),
                      enableColumnFilter: true,
                      filterFn: "includesString",
                  }));

                  setLogsColumns(cols);
                  setLogsData(data);
                  setLogsFilters({});
                  setLogsColWidths({});
                  setShowLogsModal(true);
              } else {
                  toast.info("No logs found for this TripNo.");
              }
          } catch (error) {
              console.error("Error fetching TripNo logs:", error);
              toast.error("Failed to fetch this TripNo logs.");
          }
      };
      const CallRoboCallService = async (selectedRows, totalSelected = 0) => {
        try {
            const payload = {
                refIds: selectedRows,
                affiliateID: finalAffiliate
            };
            const response = await APICom.fetchData(
                "GenericManifestDotNetCoreURL",
                "api/Notification/MarkRobocall",
                "post",
                { "Content-Type": "application/json" },
                payload
            );
            if (response && response.data) {
                console.log("API response:", response.data);
                if(response.data == "Mark robocall successfully."){
                    toast.success(`RoboCall: ${totalSelected} trip${totalSelected !== 1 ? "s" : ""} marked successfully.`, {
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true
                    });

                    
                }
                else{
                    toast.error("An Error occured while marking request(s) as RoboCall", {
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true
                    });
                }
    
                await fetchNotifications();
                setShowGridLoader(false);
            }
        } catch (error) {
            setShowGridLoader(true);
            toast.error("An Error occured while marking request(s) as RoboCall", {
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
              });
  
              await fetchNotifications();
              setShowGridLoader(false);
        }
    }

    const getRowStyle = (row) => {
        
        const isEven = row.index % 2 === 0;
        switch (row.Call_Delivery_Status.toString().toLowerCase()) {
          case "success":
            return { backgroundColor: "#d4edda", borderBottom: "1px solid rgb(94 94 94)" };
          case "fail":
            return { backgroundColor: "#f8d7da", borderBottom: "1px solid rgb(94 94 94)" };
          case "failed":
            return { backgroundColor: "#f8d7da", borderBottom: "1px solid rgb(94 94 94)" }
          case "busy":
            return { backgroundColor: "#fff3cd", borderBottom: "1px solid rgb(94 94 94)" };
          default:
            return { borderBottom: "1px solid rgb(94 94 94)"};
            return {};
        }
    };

    function GetAlreadyDeliveredRows(selectedRows) {
        try {
          if (!Array.isArray(selectedRows)) return 0;
      
          const successCount = selectedRows.filter(
            (row) => String(row.Call_Delivery_Status).toLowerCase() === "success"
          ).length;
      
          return successCount;
        } catch (error) {
          console.error("Error checking success rows:", error);
          return 0;
        }
    }

    const showAlertModal = (message, headerText = "Info") => {
        return new Promise((resolve) => {
            setModalHeaderText(headerText);
            setModalBodyHTML(message);
            setModalFooterHTML("");
            setModalClass("");
            setShowDynamicModal(true);
            // resolved when user closes via X
            modalResolveRef.current = resolve;
        });
    };

    const showConfirmationModal = (errorMsg, headerText = "Warning", yesButtonDark = true) => {
        return new Promise((resolve) => {
          const footerHandler = (
              <>
                <Button variant={yesButtonDark == true ? 'dark' : 'secondary'} className="border-0" onClick={() => {
                  setShowDynamicModal(false);
                  resolve(true);
                }}>
                  Yes
                </Button>
                <Button variant={yesButtonDark == true ? 'secondary' : 'dark'} className="border-0" onClick={() => {
                  setShowDynamicModal(false);
                  resolve(false);
                }}>
                  No
                </Button>
              </>
          );

          setModalHeaderText(headerText);
          setModalBodyHTML(errorMsg);
          setModalFooterHTML(footerHandler);
          setModalClass("");
          setShowDynamicModal(true);
          modalResolveRef.current = null;
        });
    };

    return (

        <>
        {showDynamicModal ? 
        <Modal centered className={modalClass} backdrop="static" keyboard={true} onKeyDown={(e)=>{
            if(e.key === "Enter")
            {
              e.preventDefault();
            }
          }}
           show={showDynamicModal} animation={true}
           onHide={() => {
               setShowDynamicModal(false);
               if (modalResolveRef.current) { modalResolveRef.current(); modalResolveRef.current = null; }
           }}>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
            {modalFooterHTML === ""? "":
              <Modal.Footer className='p-0 px-2 py-1'>
                {modalFooterHTML}
              </Modal.Footer>
            }
        </Modal>
      : ""}

        <div style={{ padding: "10px", paddingTop: "0px" }}>
            {ShowGridLoader ? <div className="loader"></div> : ""}

        {/* ── Toolbar ── */}
        <div style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            padding: "4px 8px",
            marginBottom: "4px",
            border: "1px solid #d3d3d3",
            borderRadius: "8px",
            background: "#f9f9f9"
        }}>

            {/* Date Picker */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                <label style={{ fontWeight: "bold", fontSize: "11px", marginBottom: "1px" }}>Selected Date</label>
                <input
                    type="date"
                    id="dateFilter"
                    className="form-control form-control-sm"
                    style={{ width: "140px" }}
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                />
            </div>

            {/* Divider */}
            <div style={{ width: "1px", height: "44px", background: "#ccc", margin: "0 2px" }} />

            {/* ── Stat Cards ── */}
            {[
                {
                    label: "Total Calls/SMS",
                    bg: "#fff",
                    items: [
                        { icon: phoneIcon, color: "darkgreen",      title: "Total Calls", val: summaryData?.["TotalCalls"]?.body ?? summaryData?.["TotalCalls"] ?? 0 },
                        { icon: smsIcon,   color: "darkslateblue",  title: "Total SMS",   val: summaryData?.["TotalSMS"]?.body   ?? summaryData?.["TotalSMS"]   ?? 0 },
                    ]
                },
                {
                    label: "Call Success/Busy",
                    bg: "#efefef",
                    items: [
                        { icon: checkIcon, color: "forestgreen", title: "Call Success", val: summaryData?.["Total_CallSuccess"]?.body ?? summaryData?.["Total_CallSuccess"] ?? 0 },
                        { icon: closeIcon, color: "darkred",     title: "Call Busy",    val: summaryData?.["Total_CallBusy"]?.body    ?? summaryData?.["Total_CallBusy"]    ?? 0 },
                    ]
                },
                {
                    label: "Sch. Confirmed Calls/SMS",
                    bg: "#fff",
                    items: [
                        { icon: callConfirmed, color: "forestgreen",   title: "Sch. Confirmed By Call", val: summaryData?.["Total_Call_Confirmed"]?.body ?? summaryData?.["Total_Call_Confirmed"] ?? 0 },
                        { icon: SMSConfirmed,  color: "darkslateblue", title: "Sch. Confirmed By SMS",  val: summaryData?.["Total_Sms_Confirmed"]?.body  ?? summaryData?.["Total_Sms_Confirmed"]  ?? 0 },
                    ]
                },
                {
                    label: "Req. Cancelled Calls/SMS",
                    bg: "#efefef",
                    items: [
                        { icon: callCancel,   color: "red",          title: "Req. Cancelled By Call", val: summaryData?.["Total_Call_Cancelled"]?.body ?? summaryData?.["Total_Call_Cancelled"] ?? 0 },
                        { icon: SMSCancelled, color: "darkslateblue",title: "Req. Cancelled By SMS",  val: summaryData?.["Total_Sms_Cancelled"]?.body  ?? summaryData?.["Total_Sms_Cancelled"]  ?? 0 },
                    ]
                },
                {
                    label: "Not Confirmed Calls/SMS",
                    bg: "#fff",
                    items: [
                        { icon: phoneMissed,  color: "orange",       title: "Not Confirmed By Call", val: summaryData?.["Total_Call_NoResponse"]?.body ?? summaryData?.["Total_Call_NoResponse"] ?? 0 },
                        { icon: SMSNoResponse,color: "darkslateblue",title: "Not Confirmed By SMS",  val: summaryData?.["Total_Sms_NoResponse"]?.body  ?? summaryData?.["Total_Sms_NoResponse"]  ?? 0 },
                    ]
                },
                {
                    label: "Routed/Not Routed",
                    bg: "#efefef",
                    items: [
                        { icon: RouteIcon, color: "green",  title: "Routed",     val: summaryData?.["Total_Scheduled"]?.body    ?? summaryData?.["Total_Scheduled"]    ?? 0 },
                        { icon: RouteIcon, color: "orange", title: "Not Routed", val: summaryData?.["Total_NotScheduled"]?.body ?? summaryData?.["Total_NotScheduled"] ?? 0 },
                    ]
                },
                {
                    label: "Voicemail/Partial Voicemail",
                    bg: "#fff",
                    items: [
                        { icon: VoicemailIcon, color: "#6a0dad", title: "Voicemail",         val: summaryData?.["Total_Voicemail"]?.body        ?? summaryData?.["Total_Voicemail"]        ?? 0 },
                        { icon: VoicemailIcon, color: "red",     title: "Partial Voicemail", val: summaryData?.["Total_PartialVoicemail"]?.body ?? summaryData?.["Total_PartialVoicemail"] ?? 0 },
                    ]
                },
            ].map((card, idx) => (
                <div key={idx} style={{
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    overflow: "hidden",
                    minWidth: "fit-content"
                }}>
                    <div style={{
                        background: "#dbdbdb",
                        fontSize: "11px",
                        fontWeight: "600",
                        textAlign: "center",
                        padding: "1px 6px",
                        whiteSpace: "nowrap"
                    }}>
                        {card.label}
                    </div>
                    <div style={{
                        background: card.bg,
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "2px 8px",
                    }}>
                        {card.items.map((item, i) => (
                            <div key={i} title={item.title} style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                fontSize: "13px",
                                fontWeight: "600"
                            }}>
                                <Icon icon={item.icon} width="16" height="16" style={{ color: item.color }} />
                                <span>{item.val}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}

            {/* Divider */}
            <div style={{ width: "1px", height: "44px", background: "#ccc", margin: "0 2px" }} />

            {/* Action Buttons */}
            {ModuleSecurity.CheckModuleSecurityByTag("tag_d2_MarkAsRoboCall") === true && (
                <button
                    className="btn btn-success btn-sm d-flex flex-column justify-content-center align-items-center"
                    onClick={handleSelectedRows}
                    title="Send RoboCall"
                    style={{ padding: "2px 10px", fontSize: "11px", gap: "1px" }}
                >
                    <Icon icon={sendIcon} width="22" height="22" />
                    <span>Send RoboCall</span>
                </button>
            )}
            <button
                className="btn btn-sm"
                onClick={RefreshData}
                title="Refresh Data"
                style={{ border: "none", background: "transparent", padding: "4px" }}
            >
                <Icon icon={refreshIcon} width="26" height="26" style={{ color: "#198754" }} />
            </button>
        </div>

        <VirtualizedTable  ref={tableRef} data={rowData}
            columns={columns} height={"80vh"}
            showCheckbox={true} hiddenColumns={columnsToHide}
            initialSelectedRows={initialSelectedRows}
            getRowStyle={getRowStyle}
            onNotificationClick={fetchTripRefLogs}
            showExportButton={true}
            exportFileName="RoboCall_Logs"
        />
        </div>
        {showLogsModal && (
          <Modal
            centered
            show={showLogsModal}
            backdrop="static"
            size="xl"
            onHide={() => { setShowLogsModal(false); setLogsFilters({}); }}
            style={{ "--bs-modal-width": "90vw" }}
          >
            <Modal.Header closeButton style={{ padding: "10px 16px" }}>
              <Modal.Title style={{ fontSize: "18px" }}>TripNo Logs</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "12px 16px", height: "55vh", overflowY: "auto" }}>
              {logsData.length > 0 ? (
                <>
                  <div style={{ border: "1px solid #ccc", borderRadius: "6px", overflow: "auto" }}>
                  <table style={{ width: "max-content", minWidth: "100%", borderCollapse: "collapse", fontSize: "13px", tableLayout: "fixed" }}>
                    {/* <col> elements — widths updated directly via DOM during drag */}
                    <colgroup>
                      {logsColumns.map((col) => (
                        <col
                          key={col.accessorKey}
                          ref={(el) => { if (el) logsColRefs.current[col.accessorKey] = el; }}
                          style={{ width: `${logsColWidths[col.accessorKey] ?? 150}px` }}
                        />
                      ))}
                    </colgroup>
                    <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                      {/* Column headers with resize handle */}
                      <tr style={{ background: "#dbdbdb" }}>
                        {logsColumns.map((col) => (
                          <th key={col.accessorKey} style={{
                            padding: "9px 10px",
                            borderBottom: "2px solid #bbb",
                            borderRight: "1px solid #ccc",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                            userSelect: "none",
                            textAlign: "left",
                            position: "relative",
                            overflow: "hidden",
                          }}>
                            {col.header}
                            {/* Resize handle */}
                            <div
                              onPointerDown={(e) => handleLogColResize(e, col.accessorKey)}
                              style={{
                                position: "absolute",
                                right: 0, top: 0,
                                width: "5px", height: "100%",
                                cursor: "col-resize",
                                userSelect: "none",
                                touchAction: "none",
                                borderRight: "2px solid #999",
                              }}
                            />
                          </th>
                        ))}
                      </tr>
                      {/* Filter row */}
                      <tr style={{ background: "#f0f0f0" }}>
                        {logsColumns.map((col) => (
                          <th key={col.accessorKey} style={{ padding: "3px 4px", borderBottom: "1px solid #ccc", borderRight: "1px solid #ccc", overflow: "hidden" }}>
                            <div style={{ position: "relative" }}>
                              <input
                                type="text"
                                placeholder="Filter..."
                                value={logsFilters[col.accessorKey] ?? ""}
                                onChange={(e) => setLogsFilters((prev) => ({ ...prev, [col.accessorKey]: e.target.value }))}
                                style={{ width: "100%", padding: "2px 20px 2px 5px", fontSize: "11px", boxSizing: "border-box", border: "1px solid #ccc", borderRadius: "3px" }}
                              />
                              {logsFilters[col.accessorKey] && (
                                <button onClick={() => setLogsFilters((prev) => ({ ...prev, [col.accessorKey]: "" }))}
                                  style={{ position: "absolute", right: "3px", top: "50%", transform: "translateY(-50%)", border: "none", background: "transparent", cursor: "pointer", fontSize: "10px", color: "#888", padding: 0 }}>
                                  ✕
                                </button>
                              )}
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLogsData.map((row, rowIdx) => (
                        <tr key={rowIdx}
                          style={{ background: rowIdx % 2 === 0 ? "#fff" : "#f7f7f7" }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = "#dbeafe"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = rowIdx % 2 === 0 ? "#fff" : "#f7f7f7"; }}
                        >
                          {logsColumns.map((col) => (
                            <td key={col.accessorKey} style={{
                              padding: "8px 10px",
                              borderBottom: "1px solid #eee",
                              borderRight: "1px solid #eee",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}>
                              {String(row[col.accessorKey] ?? "")}
                            </td>
                          ))}
                        </tr>
                      ))}
                      {filteredLogsData.length === 0 && (
                        <tr>
                          <td colSpan={logsColumns.length} style={{ padding: "20px", textAlign: "center", color: "#888" }}>
                            No records match the filter.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  </div>
                </>
              ) : (
                <div style={{ padding: "20px", textAlign: "center", color: "#888" }}>
                  No log data available for this TripRefID.
                </div>
              )}
            </Modal.Body>
            <Modal.Footer style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "13px", fontWeight: "bold", color: "#555" }}>
                Records: {filteredLogsData.length} of {logsData.length}
              </span>
              <Button variant="secondary" onClick={() => { setShowLogsModal(false); setLogsFilters({}); }}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        </>
    );
}
